import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suggested-response-time',
  templateUrl: './suggested-response-time.component.html',
  styleUrls: ['./suggested-response-time.component.css']
})
export class SuggestedResponseTimeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
